module.exports = __webpack_public_path__ + "img/49200.bb091426.jpg";